module.exports = __webpack_public_path__ + "static/media/magic.9a069996.svg";